module.exports = __webpack_public_path__ + "static/media/headerLogo.874e6d84.svg";